<template>
  <div v-loading.fullscreen.lock="loading" class="main_center clearfix">


    <el-form ref="form" :model="form" :rules='rules' label-width="150px" class="form">
      <div class="right-content">
        <el-card class="box-card" :style="{'height':cardHight}">
          <div slot="header" class="clearfix">
            <span>配置信息</span>
          </div>

          <el-row>
            <el-col :span="12">
              <el-form-item label="名称：" prop='name' style="width:100%;">
                <el-input v-model="form.name" maxlength="50" show-word-limit ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="流id：" prop='streamId' style="width:100%;">
                <el-input v-model="form.streamId" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="流媒体地址：" prop='streamUrl' style="width:100%;">
                <el-input v-model="form.streamUrl" maxlength="255" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属交易中心：" prop='interType'>
                <el-select v-model="form.tradeId"  style="width:100%;" @change="selectInterTypeClick($event)">
                  <el-option v-for="(item,index) in transactionCenterList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="发布：" prop='pubFlag' style="width:100%;">
                <el-col :span="12">
                  <el-switch
                      v-model="form.pubFlag"
                      :active-value="1"
                      :inactive-value="0"
                      active-color="#13ce66"
                      inactive-color="#c0c0c0">
                  </el-switch>
                </el-col>
              </el-form-item>
            </el-col>

          </el-row>

        </el-card>
      </div>
      <div class="left-content">
        <div class="left-navbar">
          <!--                    <right-nav :childData='listNav'></right-nav>  -->
          <el-button type="primary" size="small" plain style="margin-right:10px;" @click="save()">保存</el-button>
          <el-button size="small" @click="backBtn">返回</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>

  import {strLength_5} from '../../../utils/validate';
  import {tabsCloseCurrentHandle} from '@/utils/routeTab';

  export default {
  components: {},
  data() {
    return {
      cardHight: (document.documentElement.clientHeight - 116) + 'px',
      loading: false,
      form: {
        id: '',//id
        name: '',//名称
        streamId: '', //流id
        streamUrl: '',//流媒体地址
        pubFlag: '',//发布标记 1已发布 0未发布
        tradeId: ''
      },
      rules: {
        name: [{required: true, message: '请输入名称', trigger: 'blur'}, {validator: strLength_5, trigger: 'blur'}],
      },
      upAddIndex: '', //判断是新增还是详情页
      saveClick: false,
      errorData: {},
      transactionCenterList: [],

    }
  },
  activated() {



    this.form.id = window.sessionStorage.getItem("id");
    this.getDataById();

    this.upAddIndex = window.sessionStorage.getItem("addUpdateIndex");
    this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));


  },
  computed: {},
  methods: {


    backBtn() { //返回
      tabsCloseCurrentHandle();
      this.clearData()
      this.$router.push({
        name: 'guard_config_list'
      })

    },
    clearData() {
      this.$refs.form.resetFields();
    },
    getDataById() { //详情

      if (this.form.id != "") {

        this.$http.get('/sysGuardConfig/get?id=' + this.form.id).then(res => {
          if (res.data.code == '1') {
            this.form.id = res.data.data.id
            const data = res.data.data
            this.form = {
              id: this.form.id,
              name: data.name,//名称
              streamId: data.streamId, //流id
              streamUrl:data.streamUrl,//流媒体地址
              pubFlag: data.pubFlag,//发布标记 1已发布 0未发布
              tradeId: data.tradeId
            }
          }
        })

      } else {
        //  新增
        this.$refs['form'].resetFields();

      }
    },
    save() { //新增&保存

      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$http.post('/sysGuardConfig/save', this.form).then(res => {
            if (res.data.code == '1') {

              this.form.id = res.data.data.id
              window.sessionStorage.setItem("id", res.data.data.id);

              this.$message({
                type: 'success',
                message: res.data.msg
              })
              this.$router.push({
                name: 'guard_config_view'
              })
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
              this.errorData = res.data.data || {};
            }
          })

        }
      })
    },


  }
}
</script>

<style lang="less" scoped>
.main_center {
  height: 100%;

  .right-content {
    .set_btn {
      float: right;
      margin-bottom: 20px;
    }

    .more_btn {
      text-align: center;
    }

    .upload-demo {
      display: flex;
      height: 34px;
      border-bottom: 1px solid #dcdfe6;

      .el-button {
        position: absolute;
        right: 0;
      }
    }
  }
}

.el-dialog__body {
  padding-top: 0;

  .dia_top {
    text-align: center;
    margin-top: -3%;
  }

  .dialog_title {
    text-align: right;
    box-sizing: border-box;
    border: 1px solid #ebeef5;
    padding: 10px 10px 10px 0;
    border-bottom: none;

    .search_btn {
      margin-left: 20px;
    }
  }
}

.backBtn {
  margin-right: 10%;
}
</style>